import { render, staticRenderFns } from "./SetupStepEventsModal.vue?vue&type=template&id=2bd10f8c&scoped=true&"
import script from "./SetupStepEventsModal.vue?vue&type=script&lang=js&"
export * from "./SetupStepEventsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd10f8c",
  null
  
)

export default component.exports